const SEASON_STYLES: Record<string, { dot: string; bg: string; text: string }> = {
  Spring: { dot: "bg-[hsl(15,80%,65%)]", bg: "bg-[hsl(15,80%,96%)]", text: "text-[hsl(15,50%,40%)]" },
  Summer: { dot: "bg-[hsl(260,40%,70%)]", bg: "bg-[hsl(260,40%,96%)]", text: "text-[hsl(260,30%,40%)]" },
  Autumn: { dot: "bg-[hsl(30,70%,55%)]", bg: "bg-[hsl(30,70%,95%)]", text: "text-[hsl(30,50%,35%)]" },
  Winter: { dot: "bg-[hsl(210,30%,55%)]", bg: "bg-[hsl(210,30%,95%)]", text: "text-[hsl(210,25%,35%)]" },
};

const FALLBACK = { dot: "bg-gray-400", bg: "bg-gray-50", text: "text-gray-600" };

export default function ColourPalettePill({ palette }: { palette: string }) {
  const style = SEASON_STYLES[palette] || FALLBACK;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style.bg} ${style.text}`}
    >
      <span className={`h-2 w-2 rounded-full ${style.dot}`} />
      {palette}
    </span>
  );
}
